import Maska from 'maska';
import Vue from 'vue';

Vue.use(Maska);
